var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13404 0 0 3.13404 0 7C0 10.2827 2.26016 13.0374 5.30908 13.7939V9.1392H3.86568V7H5.30908V6.07824C5.30908 3.69572 6.38736 2.5914 8.72648 2.5914C9.17 2.5914 9.93524 2.67848 10.2483 2.76528V4.70428C10.0831 4.68692 9.79608 4.67824 9.43964 4.67824C8.29192 4.67824 7.8484 5.11308 7.8484 6.24344V7H10.1349L9.74204 9.1392H7.8484V13.9488C11.3145 13.5302 14.0003 10.579 14.0003 7C14 3.13404 10.866 0 7 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.de03198e772a6ada2cbf42af77b7306f.svg";
export { ForwardRef as ReactComponent };